import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, setSessionToken} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalPoll from './ModalPoll.js'
import {time_ago_human} from 'Skelet/src/modules/time_ago.js'

class AdminPolls extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0, modal_open:false, modal_content:{}};
  }

  componentWillMount() {
    if(!this.props.is_admin) {
      this.props.setSessionToken(null);
    }
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "hnnmw-poll-index", "GET", config.api_url+"/hnnmw-poll-index?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!nextProps.is_admin) {
      this.props.setSessionToken(null);
    }
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "hnnmw-poll-index", "GET", config.api_url+"/hnnmw-poll-index?t="+nextProps.session_token);
    }
  }

  render() {
    let cards = "", end_of_list_text = "", page_cards = this.props.apiData["hnnmw-poll-index"];
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        let created_at = new Date(item.created_at);
        let timestamp = created_at.toLocaleString();
        item.timestamp = timestamp;
        let today = new Date();
        let now = new Date();
        today.setHours(0,0,0,0);
        if(today.getTime() < created_at.getTime()) { // if created_at is today, display only the time
          timestamp = created_at.toLocaleTimeString();
        }

        let time_ago = (now.getTime() - created_at.getTime()) / 1000 / 60; // minutes
        let time_ago_txt = time_ago_human(time_ago);
        item.time_ago_txt = time_ago_txt; // @TODO_WHN this also adds this param to the stored object.. is this a problem?

        return <div key={i}>
          <small style={{marginTop:"2em", marginBottom:"10px", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>created {item.time_ago_txt} | {item.vote_count} votes</small>
          <div className="card polls card-layout">
            <div className="card-layout-div85">{item.name}</div>
            <div className="card-layout-div15 btn-detail"><Link to="/" className="btn" onClick={(e) => openModal(this, e, item)}>view</Link></div>
          </div>
        </div>;
      }.bind(this));
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Loading..";
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = ""; // End of results.
      } else {
        end_of_list_text = "No polls.";
      }
    }

    return (
      <div className="container content">
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Admin</strong></div>
          <div className="card-layout-div50 index-actions">
          </div>
        </div>
        {cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
        <ModalPoll shouldShow={this.state.modal_open} close={() => closeModal(this)} content={this.state.modal_content} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null, account_data = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    account_data: account_data,
    is_admin: (account_data.email === "hi@peter.plus") ? true : false,
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    setSessionToken,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPolls)



// WEBPACK FOOTER //
// ./src/containers/AdminPolls.js